<template>
  <div class="goal-config-general">
    <el-form :model="goalForm" @submit.native.prevent v-if="goalForm">

      <el-alert v-if="user_input_error" type="error">Error: Invalid input <!-- TODO more details --></el-alert>

      <div class="form-title">Description:</div>
      <text-editor :disabled="true" v-model="goalForm.description" />

      <el-row style="margin-top: 2em">
        <el-button type="primary" @click="onSaveSettings">Save description</el-button>
      </el-row>
    </el-form>

  </div>
</template>

<script>
export default {
  props: {
    goalId: { required: true }
  },
  data: () => ({
    goalForm: null,
    user_input_error: false,
  }),
  mounted() {
    this.goalForm = this.$models.goalMeta.getNode( this.goalId ).clone();
    this.goalForm.setValidationBehaviour('ELEMENT_VALIDATION')
    console.log("[GeneralSettingsPage] This instance will be used for editing", this.goalForm);
  },
  computed: {
  },
  methods: {
    onSaveSettings() {

      if ( !this.goalForm.$isValid() ) {
        this.user_input_error = true;
        this.user_input_invalid_list = Object.keys(this.goalForm.$invalid);
        return
      }

      console.log("this.goalForm", this.goalForm);
      let promiseUpdate = this.goalForm.write();

      promiseUpdate.then(() => {
        this.$emit('saved', this.goalForm);
      });
    },
  },
}
</script>
